/** 法务合规助手的商业层级，前后端共用以避免产品 ID 漂移。 */
export type LegalReviewTier='base'|'plus';
export const LEGAL_BASE_PRODUCT_ID='billing-product-legal';
export const LEGAL_PLUS_PRODUCT_ID='billing-product-legal-plus';
export const LEGAL_BASE_PRICE_ID='billing-price-legal-monthly';
export const LEGAL_PLUS_PRICE_ID='billing-price-legal-plus-monthly';
export function legalReviewTierForProductId(productId:string):LegalReviewTier{return productId===LEGAL_PLUS_PRODUCT_ID?'plus':'base';}
